import React from 'react';
import { Container, Nav, Navbar } from 'react-bootstrap';
import { Link, NavLink } from 'react-router-dom';
import img from '../../images/nayeem.png'
import './Header.css'

const Header = () => {
  return (
    <div className='main-header'>
       <Navbar bg="dark" variant="light" sticky="top" collapseOnSelect expand="lg">
      <Container>
        <NavLink to="/home"><img width="90px" style={{color:'gold'}} src={img} alt="" /></NavLink>
        <Navbar.Toggle />
        <Navbar.Collapse className=''>

          <Nav.Link className='link-style ms-auto' as={Link} to="/home"><h6 >Home</h6></Nav.Link>
         
          <Nav.Link className='link-style' as={Link} to="/allprojects"><h6>Projects</h6></Nav.Link>
          <Nav.Link className='link-style' as={Link} to="/about"><h6>about</h6></Nav.Link>
          <Nav.Link className='link-style' as={Link} to="/blog"><h6>blog</h6></Nav.Link>
          <Nav.Link className='link-style' as={Link} to="/contact"><h6>Contact Us</h6></Nav.Link>
          

        </Navbar.Collapse>
      </Container>
    </Navbar>

    </div>
  );
};

export default Header;